export default "__VITE_ASSET__WIZ0u06s__"